import { OnchainStateService } from './onchain-state.service';
import { Mon, MonMetadata } from '../generated/mon';
import { FacetDef, getFacet } from '../data/facets';

export interface MonDisplay {
  id: number;
  name: string;
  level: number | null;
  facet: FacetDef | null;
}

export function describeMon(onchain: OnchainStateService, id: bigint): MonDisplay {
  const equipped = onchain.getFacetForMon(id)?.equipped ?? 0;
  return {
    id: Number(id),
    name: (MonMetadata as Record<number, Mon>)[Number(id)]?.name ?? '',
    level: onchain.getLevelExp(id)?.level ?? null,
    facet: equipped > 0 ? getFacet(equipped) ?? null : null,
  };
}
